import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Flex,
} from '../../../shared/components';

export default function CaracteristicaLenteCard({
  estaSeleccionada, handleOnClick, backgroundImage, children,
}) {
  let style = null;
  if (backgroundImage) {
    style = {
      backgroundImage: `url(${backgroundImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    };
  }
  return (
    <Box className="gio-caracteristicas-lente-card" style={style}>
      <Box
        borderColor={(estaSeleccionada) ? 'primary' : 'lightgray'}
        style={{ outline: (estaSeleccionada) ? '1px solid #049bdd' : null }}
        borderWidth={1}
        borderStyle="solid"
        onClick={() => handleOnClick()}
      >
        {children}
        <Flex justifyContent="center" alignItems="center" minHeight="180px" />
      </Box>
    </Box>
  );
}

CaracteristicaLenteCard.propTypes = {
  estaSeleccionada: PropTypes.bool.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  backgroundImage: PropTypes.string,
  children: PropTypes.node.isRequired,
};
CaracteristicaLenteCard.defaultProps = {
  backgroundImage: null,
};
